import styled from "@emotion/styled";

export const IconBox = styled.div`
  display: inline-flex;
  width: ${p => p.theme.space[7]}px;
  height: ${p => p.theme.space[7]}px;
  border-radius: 50%;
  justify-content: center;
  align-items: center;

  ${({ status }) =>
    !status &&
    `
      svg circle {
        fill: ${({ theme }) => theme.colors.error.light};
      }
      svg path {
        stroke: ${({ theme }) => theme.colors.white};
      }
  `}
`;
